import React, { FC ,useState,useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { Button, Space } from 'antd'
import PageBreadcrumb from '@/components/pageBreadcrumb'
import { useTranslation } from 'react-i18next'
import { IAppState } from '@/store/reducers'
import * as go from 'gojs'
import { ReactDiagram } from 'gojs-react'
import diagramData from '@/helpers/techRelativeData.json'
import Nav from '@/components/nav'

import {  getTopic } from '@/services/table.service'

class SankeyLayout extends go.LayeredDigraphLayout {
    makeNetwork(coll: any) {
        const net = super.makeNetwork(coll)
        this.diagram?.nodes.each(node => {
        // figure out how tall the node's bar should be
            const height = this.getAutoHeightForNode(node)
            const shape = node.findObject('SHAPE')
            if (shape) shape.height = height
            const text: any = node.findObject('TEXT')
            const ltext: any = node.findObject('LTEXT')
            const font = 'bold ' + Math.max(12, Math.round(height / 8)) + 'pt Segoe UI, sans-serif'
            if (text) text.font = font
            if (ltext) ltext.font = font
            // and update the vertex's dimensions accordingly
            const v = net.findVertex(node)
            if (v !== null) {
                node.ensureBounds()
                const r = node.actualBounds
                v.width = r.width
                v.height = r.height
                v.focusY = v.height / 2
            }
        })
        return net
    }

    getAutoHeightForNode(node: any) {
        let heightIn = 0
        let it = node.findLinksInto()
        while (it.next()) {
            const link = it.value
            heightIn += link.computeThickness()
        }
        let heightOut = 0
        it = node.findLinksOutOf()
        while (it.next()) {
            const link = it.value
            heightOut += link.computeThickness()
        }
        let h = Math.max(heightIn, heightOut)
        if (h < 10) h = 10
        return h
    }

    nodeMinColumnSpace(v: any, topleft: any) {
        if (v.node === null) {
            if (v.edgesCount >= 1) {
                let max = 1
                const it = v.edges
                while (it.next()) {
                    const edge = it.value
                    if (edge.link != null) {
                        const t = edge.link.computeThickness()
                        if (t > max) max = t
                        break
                    }
                }
                return Math.max(2, Math.ceil(max / this.columnSpacing))
            }
            return 2
        }
        return super.nodeMinColumnSpace(v, topleft)
    }

    nodeMinLayerSpace(v: any, topleft: any) {
        if (v.node === null) return 100
        return super.nodeMinLayerSpace(v, topleft)
    }

    assignLayers() {
        super.assignLayers()
        const maxlayer = this.maxLayer
        // now make sure every vertex with no outputs is maxlayer
        for (let it = (this as any).network.vertexes.iterator; it.next();) {
            const v: any = it.value
            // const node = v.node
            // console.log('node: ', node?.data)
            if (v.destinationVertexes.count == 0) {
                v.layer = 0
            }
            if (v.sourceVertexes.count == 0) {
                v.layer = maxlayer
            }
        }
    }

    commitLayout() {
        super.commitLayout()
        for (let it = (this as any).network.edges.iterator; it.next();) {
            const link = it.value.link
            if (link && link.curve === go.Link.Bezier) {
                // depend on Link.adjusting === go.Link.End to fix up the end points of the links
                // without losing the intermediate points of the route as determined by LayeredDigraphLayout
                link.invalidateRoute()
            }
        }
    }
}

const TechRelative: FC = () => {
    const dispatch = useDispatch()
    const history: any = useHistory()
    const { t } = useTranslation()
    const route = useSelector((state: IAppState) => state.router)
    const [goObj, setGoObj] = useState<any>(null)
    const [topicList, setTopicList] = useState<any[]>([])
    const [nodeDataArray, setNodeDataArray] = useState<any[]>([])
    const [linkDataArray, setLinkDataArray] = useState<any[]>([])

    useEffect(() => {
        getTopicList()
    }, [])

    async function getTopicList() {
        const res = await getTopic()
        setTopicList(res)
    }
    const workgroupList = useSelector((state: IAppState) => state.tableEditData.workgroupList)
    const colorList = ['#2dc3d2','#40a840','#fec184','#9d75c2','#a1e194','#f6bcd5','#681313','#3483ba','#c9b7d8','#fea19f','#d93c3c','#a6dce6','#c9a59d','#6f3a5f']
    useEffect(() => {
        const nodeDataArray: React.SetStateAction<any[]> = []
        const linkDataArray: React.SetStateAction<any[]> = []
        let keyIndex = 1
        if(topicList && topicList.length > 0){
            topicList.forEach(item =>{
                if(item.techProjectStatus.approvalStatus && item.techProjectStatus.approvalStatus > 1){
                    let colorIndex = 0
                    workgroupList.forEach((w,index) =>{
                        if(w.id === item.techProject.techClass.workGroup.id){
                            colorIndex = index
                            return
                        }
                    })
                    const color = colorList[colorIndex]
                    let techName = ''
                    if (item.techProject.techName.includes('"str":') && item.techProject.techName.includes('"obj":')) {
                        techName = JSON.parse(item.techProject.techName).str
                        techName = techName.replace(/<\/?.+?\/?>/g,'')
                    } else {
                        techName = item.techProject.techName
                    }
                    techName = techName.replace(/\n/g, '')
                    nodeDataArray.push({ 'key':techName, 'text':`${t('Tech Name') }` + ':' + techName, 'color':color })
                    const workGroupName = item.techProject.techClass.workGroup.workGroupName
                    nodeDataArray.push({ 'key':workGroupName, 'text':`${t('WorkGroup')}` + ':' + workGroupName , 'color':color })
                    const classificationName = item.techProject.techClass.classificationName
                    nodeDataArray.push({ 'key':classificationName, 'text':`${t('techClass') }` + ':' + classificationName, 'color':color })
                    // work group ->class  -> tech -->项目-->平台 -> BU ->效益
                    linkDataArray.push({ 'key': keyIndex++, 'from':workGroupName, 'to':classificationName, 'width':31 })
                    linkDataArray.push({ 'key': keyIndex++, 'from':classificationName, 'to':techName, 'width':31 })
               
                    const projectName = item.projectName
                    if(projectName){
                        nodeDataArray.push({ 'key':projectName, 'text':`${t('projectName') }` + ':' + projectName, 'color':color })
                        linkDataArray.push({ 'key': keyIndex++, 'from':techName, 'to':projectName, 'width':31 })
                    }
                    const landingPlatform = item.landingPlatform
                    if(landingPlatform && projectName){
                        nodeDataArray.push({ 'key':landingPlatform, 'text':`${t('landingPlatform')}` + ':' + landingPlatform, 'color':color })
                        linkDataArray.push({ 'key': keyIndex++, 'from':projectName, 'to':landingPlatform, 'width':31 })
                    }
                    const applyBu = item.applyBu
                    if(applyBu && landingPlatform){
                        nodeDataArray.push({ 'key':applyBu, 'text':`${t('applyBu')}` + ':' + applyBu, 'color':color })
                        linkDataArray.push({ 'key': keyIndex++, 'from':landingPlatform, 'to':applyBu, 'width':31 })
                    }
                
                    const projectProfit = item.projectProfit
                    if(projectProfit && applyBu){
                        nodeDataArray.push({ 'key': projectProfit, 'text': `${t('projectProfit') } ` + ':' + projectProfit, 'color':color })
                        linkDataArray.push({ 'key': keyIndex++, 'from':applyBu, 'to':projectProfit, 'width':10 })
                    }
                }
            })
        }
        setNodeDataArray(nodeDataArray)
        setLinkDataArray(linkDataArray)
    }, [topicList])

    function initDiagram() {
        const $ = go.GraphObject.make  // for conciseness in defining templates
      
        const myDiagram =
            $(go.Diagram, {
                initialAutoScale: go.Diagram.UniformToFill,
                'animationManager.isEnabled': false,
                layout: $(SankeyLayout,
                    {
                        setsPortSpots: false,  // to allow the "Side" spots on the nodes to take effect
                        direction: 0,  // rightwards
                        layeringOption: go.LayeredDigraphLayout.LayerLongestPathSink, //LayerLongestPathSink,LayerLongestPathSource,LayerOptimalLinkLength
                        // packOption: go.LayeredDigraphLayout.PackStraighten || go.LayeredDigraphLayout.PackMedian,
                        packOption: go.LayeredDigraphLayout.PackNone,
                        layerSpacing: 50,  // lots of space between layers, for nicer thick links
                        columnSpacing: 10
                    }
                )
            })
        
        // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
        const colors = ['#AC193D/#BF1E4B', '#2672EC/#2E8DEF', '#8C0095/#A700AE', '#5133AB/#643EBF', '#008299/#00A0B1', '#D24726/#DC572E', '#008A00/#00A600', '#094AB2/#0A5BC4']

        // this function provides a common style for the TextBlocks
        function textStyle() {
            return { font: 'bold 12pt Segoe UI, sans-serif', stroke: 'black', margin: 5 }
        }
      
        // define the Node template
        myDiagram.nodeTemplate =
            $(go.Node, go.Panel.Horizontal,
                {
                    locationObjectName: 'SHAPE',
                    locationSpot: go.Spot.Left,
                    portSpreading: go.Node.SpreadingPacked  // rather than the default go.Node.SpreadingEvenly
                },
                $(go.TextBlock, textStyle(),
                    { name: 'LTEXT' },
                    new go.Binding('text', 'ltext')),
                $(go.Shape,
                    {
                        name: 'SHAPE',
                        fill: '#2E8DEF',  // default fill color
                        strokeWidth: 0,
                        portId: '',
                        fromSpot: go.Spot.RightSide,
                        toSpot: go.Spot.LeftSide,
                        height: 10,
                        width: 20
                    },
                    new go.Binding('fill', 'color')),
                $(go.TextBlock, textStyle(),
                    { name: 'TEXT' },
                    new go.Binding('text'))
            )
      
        function getAutoLinkColor(data: any) {
            const nodedata: any = myDiagram.model.findNodeDataForKey(data.from)
            const hex = nodedata.color
            if (hex.charAt(0) == '#') {
                const rgb = parseInt(hex.slice(1, 7), 16)
                const r = rgb >> 16
                const g = rgb >> 8 & 0xFF
                const b = rgb & 0xFF
                let alpha = 0.4
                if (data.width <= 2) alpha = 1
                const rgba = 'rgba(' + r + ',' + g + ',' + b + ', ' + alpha + ')'
                return rgba
            }
            return 'rgba(173, 173, 173, 0.25)'
        }
      
        // define the Link template
        const linkSelectionAdornmentTemplate =
            $(go.Adornment, 'Link',
                $(go.Shape,
                    { isPanelMain: true, fill: null, stroke: 'rgba(0, 0, 255, 0.3)', strokeWidth: 0 })  // use selection object's strokeWidth
            )
      
        myDiagram.linkTemplate =
            $(go.Link, go.Link.Bezier,
                {
                    selectionAdornmentTemplate: linkSelectionAdornmentTemplate,
                    layerName: 'Background',
                    fromEndSegmentLength: 150, toEndSegmentLength: 150,
                    adjusting: go.Link.End
                },
                $(go.Shape, { strokeWidth: 4, stroke: 'rgba(173, 173, 173, 0.25)' },
                    new go.Binding('stroke', '', getAutoLinkColor),
                    new go.Binding('strokeWidth', 'width'))
            )

        myDiagram.model = new go.GraphLinksModel(
            {
                copiesArrays: true,
                copiesArrayObjects: true,
                nodeDataArray: nodeDataArray,
                linkDataArray: linkDataArray,
                linkKeyProperty:'test'
            })
        setGoObj(myDiagram)
        return myDiagram
    }

    const routes = [
        {
            path: '/indexPage',
            breadcrumbName: t('indexPage'),
        },
        {
            path: '/',
            breadcrumbName: t('Tech Relative'),
        },
    ]
    const zoomToFit = () => {
        goObj && goObj.commandHandler.zoomToFit()
    }
    return (<>
        <Space direction="vertical" size={10} style={{ width: '100%' }}>
            <Nav dispatch={dispatch} />
            <PageBreadcrumb routerParam={routes}
                history={history}
                route={route}
                dispatch={dispatch}
            />
            <ReactDiagram
                divClassName={diagramData.class}
                initDiagram={initDiagram}
                nodeDataArray={nodeDataArray}
                linkDataArray={linkDataArray}
            />
            <Space style={{ display: 'flex', justifyContent: 'flex-end',paddingRight:'50px' }}>
                <Button onClick={zoomToFit}>{t('Zoom To Fit')}</Button>
            </Space>
        </Space>
    </>)
}
export default TechRelative